module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "navbar navbar-default navbar-fixed-top",
    attrs: {
      "id": "navbar",
      "role": "banner"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.overlaySuperior) ? _c('div', {
    attrs: {
      "id": "overlay"
    },
    on: {
      "click": function($event) {
        return _vm.toggleMenuSuperior()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.overlayLateral) ? _c('div', {
    attrs: {
      "id": "overlay"
    },
    on: {
      "click": function($event) {
        return _vm.toggleMenuLateral()
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row hidden-xs hidden-sm"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('router-link', {
    staticClass: "navbar-brand navbar-brand-topo",
    attrs: {
      "to": "/",
      "title": "Início"
    }
  }, [_vm._v("Prefeitura de Santos")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.autenticado),
      expression: "autenticado"
    }],
    staticClass: "col-md-9"
  }, [_c('button', {
    staticClass: "navbar-toggle show",
    attrs: {
      "type": "button",
      "id": "btn-menu-superior"
    },
    on: {
      "click": function($event) {
        return _vm.toggleMenuSuperior()
      }
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Menu lateral")]), _vm._v(" "), _c('span', {
    staticClass: "btntxt"
  }, [(_vm.usuario) ? _c('span', [_vm._v("Olá " + _vm._s(_vm.usuario) + "  ")]) : _c('span', [_vm._v("Olá " + _vm._s(_vm.sshd) + "  ")]), _vm._v(" "), (_vm.autenticados && _vm.autenticados.length > 1) ? _c('span', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.bottom",
      value: ('Trocar Registro'),
      expression: "'Trocar Registro'",
      modifiers: {
        "bottom": true
      }
    }],
    staticStyle: {
      "font-size": "0.9em"
    }
  }, [_vm._v(_vm._s(_vm.funcionario.registroFormatado) + "  ")]) : _vm._e()]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "upper-off-canvas"
  }, [_c('div', {
    attrs: {
      "id": "menu-superior"
    }
  }, [_c('h3', [_vm._v("Usuário")]), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-pills nav-stacked",
    attrs: {
      "id": "main-menu"
    }
  }, [(_vm.autenticados && _vm.autenticados.length > 1) ? _c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    },
    on: {
      "click": function($event) {
        _vm.paraBaixoTrocaRegistro = !_vm.paraBaixoTrocaRegistro
      }
    }
  }, [_vm._v("\n                  Trocar Registro\n                  "), _c('span', {
    staticClass: "to-the-right"
  }, [_c('i', {
    class: _vm.downUp(_vm.paraBaixoTrocaRegistro)
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    on: {
      "click": function($event) {
        return _vm.toggleMenuSuperior()
      }
    }
  }, [_c('li', _vm._l((_vm.autenticados), function(user) {
    return _c('a', {
      key: user.id,
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.trocaRegistro(user)
        }
      }
    }, [_vm._v("\n                      " + _vm._s(user.registroFormatado) + "\n                    ")])
  }), 0), _vm._v(" "), _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  })])]) : _vm._e(), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.toggleMenuSuperior()
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "https://egov.santos.sp.gov.br/websshd",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("Trocar Senha")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.toggleMenuSuperior()
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Conta'
      }
    }
  }, [_vm._v("Meus Dados")])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.toggleMenuSuperior()
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Sair'
      }
    }
  }, [_vm._v("Sair")])], 1)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row visible-xs visible-sm"
  }, [_c('div', {
    staticClass: "col-xs-8 col-sm-4"
  }, [_c('router-link', {
    staticClass: "navbar-brand navbar-brand-topo",
    attrs: {
      "to": "/",
      "title": "Início"
    }
  }, [_vm._v("Prefeitura de Santos")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.autenticado),
      expression: "autenticado"
    }],
    staticClass: "col-xs-4 col-sm-8"
  }, [_c('button', {
    staticClass: "navbar-toggle show",
    attrs: {
      "type": "button",
      "id": "btn-menu-lateral"
    },
    on: {
      "click": function($event) {
        return _vm.toggleMenuLateral()
      }
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Menu lateral")]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "off-canvas"
  }, [_c('div', {
    attrs: {
      "id": "menu-lateral"
    }
  }, [_c('img', {
    staticStyle: {
      "margin-top": "-15px",
      "margin-left": "-21px"
    },
    attrs: {
      "src": require("../../assets/LogoXs.jpg"),
      "alt": "Logo Central Servidor"
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Aplicação")]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav",
    attrs: {
      "id": "main-menu"
    }
  }, [_c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    },
    on: {
      "click": function($event) {
        _vm.paraBaixoDeclaracao = !_vm.paraBaixoDeclaracao
      }
    }
  }, [_vm._v("\n                Declarações\n                "), _c('span', {
    staticClass: "to-the-right"
  }, [_c('i', {
    class: _vm.downUp(_vm.paraBaixoDeclaracao)
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    on: {
      "click": function($event) {
        return _vm.toggleMenuLateral()
      }
    }
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'DeclaracaoBens'
      }
    }
  }, [_vm._v("Declaração de Bens")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Dependente'
      }
    }
  }, [_vm._v("Parceiro Econômico")])], 1), _vm._v(" "), _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    },
    on: {
      "click": function($event) {
        _vm.paraBaixoAvaliacao = !_vm.paraBaixoAvaliacao
      }
    }
  }, [_vm._v("\n                Avaliações\n                "), _c('span', {
    staticClass: "to-the-right"
  }, [_c('i', {
    class: _vm.downUp(_vm.paraBaixoAvaliacao)
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    on: {
      "click": function($event) {
        return _vm.toggleMenuLateral()
      }
    }
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Avaliacao'
      }
    }
  }, [_vm._v("Avaliação Periódica")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'AvaliacaoEstagioProbatorio'
      }
    }
  }, [_vm._v("Estágio Probatório")])], 1), _vm._v(" "), _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    },
    on: {
      "click": function($event) {
        _vm.paraBaixoRecadastro = !_vm.paraBaixoRecadastro
      }
    }
  }, [_vm._v("\n                Atualização Cadastral\n                "), _c('span', {
    staticClass: "to-the-right"
  }, [_c('i', {
    class: _vm.downUp(_vm.paraBaixoRecadastro)
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    on: {
      "click": function($event) {
        return _vm.toggleMenuLateral()
      }
    }
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'MesCompetenciaOrdenado'
      }
    }
  }, [_vm._v("Dados Pessoais")])], 1), _vm._v(" "), _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    },
    on: {
      "click": function($event) {
        _vm.paraBaixoFerias = !_vm.paraBaixoFerias
      }
    }
  }, [_vm._v("\n                Férias\n                "), _c('span', {
    staticClass: "to-the-right"
  }, [_c('i', {
    class: _vm.downUp(_vm.paraBaixoFerias)
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    on: {
      "click": function($event) {
        return _vm.toggleMenuLateral()
      }
    }
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Ferias'
      }
    }
  }, [_vm._v("Agendamento de Férias\n                  ")])], 1), _vm._v(" "), (_vm.ehResponsavelAprovador) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Aprovacao'
      }
    }
  }, [_vm._v("\n                    Aprovação de Férias\n                  ")])], 1) : _vm._e()])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    },
    on: {
      "click": function($event) {
        _vm.paraBaixoFormulario = !_vm.paraBaixoFormulario
      }
    }
  }, [_vm._v("\n                Formulários\n                "), _c('span', {
    staticClass: "to-the-right"
  }, [_c('i', {
    class: _vm.downUp(_vm.paraBaixoFormulario)
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    on: {
      "click": function($event) {
        return _vm.toggleMenuLateral()
      }
    }
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'FaltaLei'
      }
    }
  }, [_vm._v("Falta Lei")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'DeclaracaoInclusaoImpostoRenda'
      }
    }
  }, [_vm._v("Declaração de Inclusão\n                    IR")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'DeclaracaoExclusaoImpostoRenda'
      }
    }
  }, [_vm._v("Declaração de Exclusao\n                    IR")])], 1), _vm._v(" "), _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    },
    on: {
      "click": function($event) {
        _vm.paraBaixoLinks = !_vm.paraBaixoLinks
      }
    }
  }, [_vm._v("\n                Links\n                "), _c('span', {
    staticClass: "to-the-right"
  }, [_c('i', {
    class: _vm.downUp(_vm.paraBaixoLinks)
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    on: {
      "click": function($event) {
        return _vm.toggleMenuLateral()
      }
    }
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  })])])]), _vm._v(" "), _c('h3', [_vm._v("\n            Usuário\n            "), (_vm.autenticados && _vm.autenticados.length > 1) ? _c('span', {
    staticStyle: {
      "font-size": "0.9em",
      "font-weight": "700",
      "color": "#b9d8b3"
    }
  }, [_vm._v("  " + _vm._s(_vm.funcionario.registroFormatado))]) : _vm._e()]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav",
    attrs: {
      "id": "user-menu"
    }
  }, [(_vm.autenticados && _vm.autenticados.length > 1) ? _c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    },
    on: {
      "click": function($event) {
        _vm.paraBaixoTrocaRegistro = !_vm.paraBaixoTrocaRegistro
      }
    }
  }, [_vm._v("\n                Trocar Registro\n                "), _c('span', {
    staticClass: "to-the-right"
  }, [_c('i', {
    class: _vm.downUp(_vm.paraBaixoTrocaRegistro)
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    on: {
      "click": function($event) {
        return _vm.toggleMenuLateral()
      }
    }
  }, [_c('li', _vm._l((_vm.autenticados), function(user) {
    return _c('a', {
      key: user.id,
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.trocaRegistro(user)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(user.registroFormatado) + "\n                  ")])
  }), 0), _vm._v(" "), _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  })])]) : _vm._e(), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.toggleMenuLateral()
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "https://egov.santos.sp.gov.br/websshd",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("Trocar Senha")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.toggleMenuLateral()
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Conta'
      }
    }
  }, [_vm._v("Meus Dados")])], 1), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-bottom": "32px"
    },
    on: {
      "click": function($event) {
        return _vm.toggleMenuLateral()
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Sair'
      }
    }
  }, [_vm._v("Sair")])], 1)])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "btnico"
  }, [_c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "btnico"
  }, [_c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "https://egov.santos.sp.gov.br/jornada",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Jornada\n                  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "https://egov.santos.sp.gov.br/jornada/downloads/manual.pdf",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-book",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Manual\n                    Jornada\n                  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "https://egov.santos.sp.gov.br/jornada/downloads/formularios.docx",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Anexo Único\n                  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "https://entrega.santos.sp.gov.br",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-cloud-upload",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Entrega\n                  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "https://webmail.santos.sp.gov.br",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" WebMail\n                  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "https://egov.santos.sp.gov.br/sigm_web_adm_sistema",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('i', {
    staticClass: "fa fa-stethoscope",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Perícia Médica\n                  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "https://egov.santos.sp.gov.br/contador",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('i', {
    staticClass: "fa fa-usd",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Holerite\n                  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "https://egov.santos.sp.gov.br/contador",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('i', {
    staticClass: "fa fa-paw",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Informe\n                    de Rendimentos\n                  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "https://egov.santos.sp.gov.br/contador",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Contagem de Tempo\n                  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "https://egov.santos.sp.gov.br/legis/documents/55",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('i', {
    staticClass: "fa fa-balance-scale",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Estatuto\n                  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "https://www.santos.sp.gov.br/portal/servidor",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('i', {
    staticClass: "fa fa-globe",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Portal\n                    do Servidor\n                  ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4cf4c8e7","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/barra-navegacao/index.vue
// module id = ze16
// module chunks = 5